import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getTestimony() {
  const data = await axiosInstance({
    url: "/testimony",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createTestimony(formData) {
  const data = await axiosInstance({
    url: "/testimony",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updateTestimony(formData) {
  const data = await axiosInstance({
    url: `/testimony/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deleteTestimony(formData) {
  const data = await axiosInstance({
    url: `/testimony/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function useTestimony() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.testimony],
    queryFn: getTestimony,
  });
  return data;
}

export function useUpdateTestimony() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updateTestimony(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.testimony]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddTestimony() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createTestimony(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.testimony]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeleteTestimony() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deleteTestimony(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.testimony]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
